import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageActionsDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        flexShrink: 0
    }
});

export const useStyles = ({
    spaces
}: MessageActionsDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingXxs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
